
import { ControlFacet } from '../models/controls/ControlFacet';
import { ICommand } from '../models/commands/ICommand';

export const itemsCommandBarControl = new ControlFacet<{
  itemKey: string;
  itemSetKey?: string;
}, {
    commands: ICommand[];
    overflowCommands: ICommand[];
    farCommands: ICommand[];
    shortcutCommands: ICommand[];
  }>('itemsCommandBarControl');
